var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"title":_vm.$route.query.cateName}},[_c('div',{staticStyle:{"height":"100%"},attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"h-2"}),_c('GoodsList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }